"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Libraries_1 = require("./Libraries");
var FlatList = function (_a) {
    var data = _a.data, renderItem = _a.renderItem, numberOfColumn = _a.numberOfColumn;
    var _b = (0, react_1.useState)([]), processedList = _b[0], setProcessedList = _b[1];
    (0, react_1.useEffect)(function () {
        var chunk = (0, Libraries_1.chunkArray)(data, numberOfColumn);
        setProcessedList(chunk);
    }, [data, numberOfColumn]);
    var renderRow = function (items, index) {
        return (react_1.default.createElement("div", { key: index, style: {
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-evenly",
                alignItems: "flex-start",
            } }, items.map(function (item, index) {
            return react_1.default.createElement(react_1.Fragment, { key: index }, renderItem(item, index));
        })));
    };
    return (react_1.default.createElement("div", { style: {
            display: "flex",
            // borderColor: "#000",
            borderWidth: 1,
            // background: "#00ff00",
            flexDirection: "column",
            flex: 1,
            height: "100%",
            justifyContent: "flex-start",
            alignItems: "flex-start",
        } }, processedList.map(function (l, index) {
        return renderRow(l, index);
    })));
};
exports.default = FlatList;
